import { BrowserRouter as Router, Route, Link, Switch, useParams } from "react-router-dom";
import * as React from 'react';
import { TApiResponse, Immagine, MuseComunicazioneIngresso, MuseComunicazioniUscita, MuseComunicazione } from './types';
import { ApiClient, IApiClient } from "../http_client/api_client";
import DOMPurify from "dompurify";

// Funzioni di utilità
export function RouteWithSubRoutes(route,updateFunction:void) {
    return (
      <Route path={route.path} render={props => (
          // pass the sub-routes down to keep nesting
          <route.component {...props} routes={route.routes} updateBreadcrumb={updateFunction}  />
        )}
      />
    );
}

export function localDatetime(datetimeFromBE: string, soloTime: boolean = false){
  let date = Date.parse(datetimeFromBE.split("+")[0]+"+00:00");
  const dateOptions = { timeZone: 'UTC', month: '2-digit', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' };
  const timeOptions = { timeZone: 'UTC', hour: '2-digit', minute: '2-digit' };
  if(soloTime){
    const timeFormatter = new Intl.DateTimeFormat('it-IT', timeOptions);
    return timeFormatter.format(new Date(date));
  }else{
    const dateFormatter = new Intl.DateTimeFormat('it-IT', dateOptions);
    return dateFormatter.format(new Date(date));
  }
}


export const getCookie = (key: string): string => {
  let b = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
  return b ? b.pop() : "";
}

/* ritorna un hash da passare al client http per fare chiamate Post */
export const getParamsPost = (event: React.FormEvent): any => {
  let hash_params_submit = {};
  /* Nome del campo che ha fatto il submit, mi serve sul controller per capire che submit viene fatto se ci sono n form */
  if(event.nativeEvent && event.nativeEvent?.submitter.name !== "" && event.nativeEvent?.submitter.name !== null)
  hash_params_submit[event.nativeEvent?.submitter.name ] = event.nativeEvent?.submitter.value;
  /* creo un hash da passare al client http per fare post, salvo name e value ('on' come value del checkbox, tranne se arriva 1 per moduli) */
  Array.prototype.forEach.call(event.currentTarget.elements, (element) => {
    if(element.name && element.name !== "" && element.name !== null) { /* se non ho i name non faccio invio del valore */
      if(element.tagName == 'INPUT'){
        if(element.type == 'checkbox'){
          if(element.checked && element.name){
            if(element.value == '1'){ /* Per salvataggio dati su modulistica */
              hash_params_submit[element.name ] = '1';
            }else{
              hash_params_submit[element.name ] = 'on';
            }
          }
        }else if(element.type == 'radio'){
          if(element.checked && element.name){
            hash_params_submit[element.name ] = element.value;
          }
        }else{
          if(element.type == 'file'){
            if(element.files.length > 0){
              hash_params_submit[element.name ] = element.files[0];
            }
            
          }else{
            hash_params_submit[element.name ] = element.value;
          }
        }
      }
      if(element.tagName == 'SELECT'){
        hash_params_submit[element.name ] = element.value;
      }
      if(element.tagName == 'TEXTAREA'){
        hash_params_submit[element.name ] = element.value;
      }
    } 
  });
  return hash_params_submit;
}


export const getParamsFromQuerystring = (url: string): any => {
  if(url.includes('?')){
    let query = null;
    if(url.includes('#')){
      query = url.split('#')[1].split('?')[1];
    }else{
      query = url.split('?')[1];
    }
    let params = Object.fromEntries(new URLSearchParams(query));
    return params;
  }else{
    return null;
  }
  
}

export const uniqArrayObj = (array: any[]): any[] => {
  if(array.length > 0){
    return [...new Map(array.map(itemArray => [itemArray[Object.keys(itemArray)[0]], itemArray])).values()];
  }else{
    []
  }
}

export const capitalizeFirstLetter = (txt: string) : string => {
  return txt.charAt(0).toUpperCase() + txt.slice(1);
}

export const isType = (x: any, typeToCheck: string): boolean => {
  return Object.prototype.toString.call(x) === "[object "+capitalizeFirstLetter(typeToCheck)+"]"
}

export const sanitizeText = (txt: string) :string => {
  const cleanHTML = DOMPurify.sanitize(txt, {
    USE_PROFILES: { html: true },
  });
  return cleanHTML;
}

//Funzione per url_redirect da Api presente su views, corregge problema relativo a es: portalepa.siracusa.it/portal e relativi suburl
export const pathRedirect = (url_string: string) : string => {
    if(url_string.split('/portal/')[1] != undefined){
      //return url_string.split('/portal/')[1];
      return url_string.replace(url_string.split('/portal/')[0]+'/portal/','');
  }else{
      return "";
  }
}


//validazione dei campi di input rispetto al pattern usato all'interno di ognuno, al required e se la data è fino ad oggi
export const validateInputForm = (target: HTMLInputElement): boolean => {
  const re = new RegExp(target.pattern);
  const data_corrente = new Date();
  const description = document.getElementById(`${target.id}Description`) || document.getElementById(`${target.id.replace('Required','')}Description`)

  if (target.value && target.type != 'date') {
      /////////////////////////////////////////
      // if(condizionePerFarCapireCellPendente){
      //     target.classList.add('is-invalid')
      //     target.classList.remove('is-valid')
      //     const infoDiv = document.getElementById(target.id + "Description").textContent = 'Cellulare da confermare'
      //     //Aggiungere un nodo figlio all'infoDiv con <a href="" >Conferma cellulare: 1262636</a>
      // }
      /////////////////////////////////////////


      if (re.test(target.value)) {
          target.classList.add('is-valid')
          target.classList.remove('is-invalid')

          if (description != null) {
              description.textContent = '' //'validato'
          }

          return true;

      } else {
          target.classList.add('is-invalid')
          target.classList.remove('is-valid')

          if (description != null) {
              description.textContent = 'Formato non corretto'
          }

          return false;

      }
  } else if (target.value && target.type === 'date') {
      const data_inserita = new Date(target.value)
      if (data_inserita < data_corrente) {
          target.classList.add('is-valid')
          target.classList.remove('is-invalid')

          if (description != null) {
              description.textContent = '' //'validato'
          }

          return true;

      } else {
          target.classList.add('is-invalid')
          target.classList.remove('is-valid')

          if (description != null) {
              description.textContent = 'Data non valida'
          }

          return false;
      }
  } else if (target.required || target.id.includes('Required')) {
      target.classList.add('is-invalid');
      target.classList.remove('is-valid');

      if (description != null) {
          description.textContent = 'Questo campo non può essere vuoto';
      }

      return false;
  }

  return true;
}


// Funzioni asincrone

export async function getConfEnte(apiClient: IApiClient): Promise<TApiResponse> {
  console.log("Faccio chiamata a getConfEnte");
  try{
     const response = await apiClient.get<TApiResponse>('portal/conf_ente');
     return response != null ? response : null;
  } catch (exception) {
     console.error("getConfEnte failed"+exception);
  }
}

export async function getConfEnteHippo(apiClient: IApiClient): Promise<TApiResponse> {
  console.log("Faccio chiamata a getConfEnte");
  try{
     const response = await apiClient.get<TApiResponse>('portal/api/info_ente.php');
     return response != null ? response : null;
  } catch (exception) {
     console.error("getConfEnteHippo failed"+exception);
  }
}



export async function getScene(apiClient: IApiClient,url: string, updateLoader: any, setContext: any = null): Promise<TApiResponse | null | undefined> {

  console.log("Faccio chiamata a getScene con url: " + url);
  if (updateLoader) {
    updateLoader(true);
  }
  try {

    const response = await apiClient.get<TApiResponse>(url);
    /* se la risposta della get_scene sul be è data dal json di autenticazione_necessaria */
    if (response?.dati?.sessione_scaduta) {
      
      if (setContext) {
        setContext({ userLogged: false })
      }
    }

    if (updateLoader) {
      updateLoader(false);
    }
    
    return response ?? null;
  
  } catch (exception) {
    if (updateLoader) {
      updateLoader(false);
    }
    console.error(`getScene failed with url ${url} :${exception}`);
  }
  //N.B: non tutti i componenti hanno le props delle view... getScene non è usato solo per le pagine?
}

export async function getUrl(apiClient: IApiClient,url: string): Promise<TApiResponse> {
  console.log("Faccio chiamata a getUrl");
  try{
     const response = await apiClient.get<TApiResponse>(url);
     return response != null ? response : null;
  } catch (exception) {
     console.error(`getUrl failed with url ${url} :${exception}`);
  }
}


export async function inviaDatiPost( apiClient: IApiClient, path: string, postData: any, updateLoader: any, setContext: any ): Promise<TApiResponse> {
  console.log("Invio dati post al backend");
  console.log(postData);
  if(updateLoader) updateLoader(true);
  
  try{
    /* per fare le chiamate in post devo mettere lo slash finale! */
    if(path.slice(-1) != '/') path+='/'
    const response: TApiResponse = await apiClient.post(path, postData);
    if(updateLoader) updateLoader(false);
    if (response && response.dati && response.dati.sessione_scaduta) {
      if (setContext) {
        setContext({userLogged: false})
      }
    }
    return response != null ? response : null;
  } catch (exception) {
    if(updateLoader) updateLoader(false);
    console.error(`inviaDatiPost path ${path} failed : ${exception}`);
  }
}

// restituisce l'immagine nella vetrina del punto di erogazione(pre_auth) e della galleria del dettaglio_punto_erogazione
export async function getImmagine_puntoErogazione(apiClient: IApiClient, idImmagine: number, updateLoader: any): Promise<string> {
  if(updateLoader) updateLoader(true);
  console.log("Carico immagine struttura...");
  try{
    const response = await apiClient.get<string>('portal/servizi/muse/immagine_vetrina/'+idImmagine);
    if(updateLoader) updateLoader(false);
    return response != null ? response : null;
  } catch (exception) {
    if(updateLoader) updateLoader(false);
    console.error("getImmagine_puntoErogazione failed" + exception);
  }
} 

export async function getPuntiErogazione( apiClient: IApiClient, idAnnoServizio: number, updateLoader: any): Promise<any> {
  if(updateLoader) updateLoader(true);
  try{
    console.log("Get punti erogazione ...");
    const response = await apiClient.get<TApiResponse>('portal/servizi/muse/iscrizione/get_punti_erogazione/'+ idAnnoServizio);
    console.log(response.dati);
    if(updateLoader) updateLoader(false);
    return response != null ? response : null;
  }catch(exception){
    if(updateLoader) updateLoader(false);
    console.error("get punti erogazione failed" + exception);
  }
}

export async function getDettaglioMovimentoContabile( apiClient: IApiClient, idMovimentoContabile: number, updateLoader: any): Promise<any> {
  if(updateLoader) updateLoader(true);
  try{
    console.log("Get movimento contabile ...");
    const response = await apiClient.get<TApiResponse>('portal/servizi/muse/dettaglio_movimento_contabile/'+ idMovimentoContabile);
    console.log(response.dati);
    if(updateLoader) updateLoader(false);
    return response != null ? response : null;
  }catch(exception){
    if(updateLoader) updateLoader(false);
    console.error("get movimento contabile failed" + exception);
  }
}

export async function getMuseDettaglioGraduatoria( apiClient: IApiClient, idGraduatoria: string, updateLoader: any): Promise<any> {
  if(updateLoader) updateLoader(true);
  try{
    console.log("Get movimento contabile ...");
    const response = await apiClient.get<TApiResponse>('portal/servizi/muse/iscrizione/dettaglio_graduatoria/'+ idGraduatoria);
    console.log(response.dati);
    if(updateLoader) updateLoader(false);
    return response != null ? response : null;
  }catch(exception){
    if(updateLoader) updateLoader(false);
    console.error("get movimento contabile failed" + exception);
  }
}

//Questa funzione converte una stringa logCalcolo in un oggetto con chiavi descrittive e valore corrispondente :
// ES, la stringa logCalcolo
// "GG E/F/A: 15/7/5\r\nISEE: 5.325,00\r\nTariffa C/QF/QV: B/30,00/4,50\r\nSconto figli: 0,00"
// Diventa :
// {
//   "Giorni effettivi del servizio": " 15",
//   "Giorni fruiti": "7",
//   "Giorni addebbitati": "5",
//   "ISEE": " 5.325,00",
//   "Codice tariffa applicata": " B",
//   "Importo quota fissa": "30,00",
//   "Importo quota fissa variabile": "4,50",
//   "Sconto figli": " 0,00"
// }
export function logCalcoloDettaglioMovimentoContabileToObject(logContabile:string) {
  
  let oggettoLog = {};

  for (const elemento of logContabile.split(/\r\n/)) {

    const tipoElemento = elemento.split(/:/);

    // Se il dettaglio in questione è un isee o uno sconto figlio, mi fermo, lo aggiungo all'oggetto
    if (tipoElemento[0].match(/ISEE/) || tipoElemento[0].match(/Sconto figli/)) {
      
      // In questo caso non ci sono altre valutazioni da fare, il dato è unico
      //  il secondo elemento della chiave è il valore dell'elemento contabile
      oggettoLog[tipoElemento[0]] = tipoElemento[1];
      continue
    }

    const chiaviElemento = tipoElemento[0].split(/\s/)[1].split(/\//);
    const datiElemento = tipoElemento[1].split(/\//);

    // recupero il valore espresso nella stringa
    chiaviElemento.forEach((chiave, index) => {

      // assegno il valore a una chiave più descrittiva
      switch (chiave) {
        case 'C':
          oggettoLog['Codice tariffa applicata'] = datiElemento[index];
        
        break;
        
        case 'QF':
          oggettoLog['Importo quota fissa'] = datiElemento[index];
        
        break;
       
        case 'QV':
          oggettoLog['Importo quota fissa variabile'] = datiElemento[index];
        
        break;
          
        case 'E':
          oggettoLog['Giorni effettivi del servizio'] = datiElemento[0];
        
        break;
        
        case 'F':
          oggettoLog['Giorni fruiti'] = datiElemento[1];
        
        break;
        
        case 'A':
          oggettoLog['Giorni addebbitati'] = datiElemento[2];
        
        break;
      
      }

    });

  }

  return oggettoLog
}

export async function MuseStampaRT(iuv: string, apiClient: IApiClient, updateLoader, setContext) {
  let param = { "iuv": iuv }
  const responseApi: TApiResponse = await inviaDatiPost(apiClient, "/portal/servizi/muse/stampa_rt", param, updateLoader, setContext);
  console.log(responseApi);

  if (responseApi.esito == 'ok') {
    const a = document.createElement('a')
    a.hidden = true;
    a.download = responseApi.dati.filename
    a.href = 'data:application/pdf;base64,' + responseApi.dati.pdf
    a.click()
  } else {
    return ({ flash: responseApi.flash })
  }
  window.scrollTo(0, 0);
}

export async function MusePaga(iuv, apiClient: IApiClient, updateLoader, setContext) {
  let param = { "location": window.location, "iuv": iuv }
  const responseApi: TApiResponse = await inviaDatiPost(apiClient, "/portal/servizi/muse/avvia_pagamento", param, updateLoader, setContext);

  if (responseApi.esito == 'ok') {
    window.location = responseApi.dati.url_redirect
  } else {
    return ({ flash: responseApi.flash })
  }
  window.scrollTo(0, 0);
}



export const MuseGetDestinatarioComunicazione = (comunicazione: MuseComunicazioneIngresso | MuseComunicazioniUscita | MuseComunicazione) => {
  if (!comunicazione) {
    console.log("Inserito un valore non valido");
    return ''
  }


  let destinarioComunicazione = ''
  if (comunicazione.idClasseSezione) {
    destinarioComunicazione = 'Classe'
  }
  if ("denominazioneInsegnante" in comunicazione) {
    destinarioComunicazione = comunicazione.denominazioneInsegnante
  }

  if (!destinarioComunicazione) {
    //  Può essere solo Privata o di Plesso
    if ("idPuntoErogazione" in comunicazione) {
      if (comunicazione.idPuntoErogazione) {
        destinarioComunicazione = 'Plesso'
      } else {
        destinarioComunicazione = 'Privata'
      }
    }

    if ('denominazioneMittente' in comunicazione) {
      destinarioComunicazione = 'Ufficio'
    }


  }

  return destinarioComunicazione

}


export const MuseGetDateObj = (dateMuse: string) => {
  const [day, month, yearAndTime] = dateMuse.split("/");
  const [year, time] = yearAndTime.split(" ");
  return new Date(`${year}-${month}-${day? day : '00'}T${time? time : '00'}:00`);
}

export const ConvItDateToUs = (data: string) => {
  var dateParts = data.split("/");
  // month is 0-based, that's why we need dataParts[1] - 1
  let data_conv = new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]);
  let year = data_conv.toLocaleString("default", { year: "numeric" });
  let month = data_conv.toLocaleString("default", { month: "2-digit" });
  var day = data_conv.toLocaleString("default", { day: "2-digit" });

  // Generate yyyy-mm-dd date string
  return year + "-" + month + "-" + day;
}

